import ArrowRightIcon from '@/common/assets/icons/arrowRightIcon.svg?react';
import Button from '@/common/components/base/button/Button.tsx';
import useModal from '@/common/hooks/useModal';
import { Center } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import ShowDescriptionModal from '@/modules/FileDetail/components/statusTransition/modals/ShowDescriptionModal.tsx';
import { ShowDescriptionType } from '@/modules/FileDetail/components/statusTransition/statusTransitionAction/StatusTransitionAction.type.ts';
import { css } from 'styled-system/css';

export default ({ description }: ShowDescriptionType) => {
  const { open, closeModal, openModal } = useModal();

  return (
    <>
      <Center borderTop="1px solid {colors.gray-2}">
        <Button fullWidth variant="text" color="primary" onClick={openModal}>
          مشاهده توضیحات
          <ArrowRightIcon
            stroke={token('colors.purple-2')}
            width={14}
            className={css({
              marginRight: '10px',
              position: 'relative',
              top: '1px',
            })}
          />
        </Button>
      </Center>
      <ShowDescriptionModal
        open={open}
        closeModal={closeModal}
        description={description}
      />
    </>
  );
};
